module.exports = __webpack_public_path__ + "img/autogames.11721187.svg";